<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sms__coupon">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.couponNo" placeholder="门票码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.name" placeholder="门票名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.couponName" placeholder="优惠券名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <template>
            <div class="block">
              <el-date-picker
                      v-model="dataForm.beginDate"
                      type="date"
                      :clearable="true"
                      format="yyyy年MM月dd日"
                      value-format="yyyy-MM-dd"
                      placeholder="有效开始时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item>
          <template>
            <div class="block">
              <el-date-picker
                      v-model="dataForm.endDate"
                      type="date"
                      :clearable="true"
                      format="yyyy年MM月dd日"
                      value-format="yyyy-MM-dd"
                      placeholder="截止时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportTemplateHandle()">导出模板</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload  class="upload-demo"
                      action=""
                      ref="upload"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      :http-request="uploadFile"
                      multiple
                      :limit="1"
                      :show-file-list="false">
            <el-button  type="primary">导入门票码</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sms:ticketcoupon:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="couponNo" label="门票码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="门票名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="couponName" label="优惠券名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="banlanceAmt" label="抵扣金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status===1">未激活</el-tag>
            <el-tag v-else-if="scope.row.status===2">已激活</el-tag>
            <el-tag v-else-if="scope.row.status===3">已使用</el-tag>
            <el-tag v-else-if="scope.row.status===4">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="effectiveDate" label="使用日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="expireDate" label="截止日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sms:ticketcoupon:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sms:ticketcoupon:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './couponticket-add-or-update'
import qs from "qs";
import Cookies from "js-cookie";
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sms/ticketcoupon/page',
        getDataListIsPage: true,
        exportURL: '/sms/ticketcoupon/export',
        deleteURL: '/sms/ticketcoupon',
        deleteIsBatch: true
      },
      exportTemplateURL: '/sms/ticketcoupon/exportTemplate',
      dataForm: {
        couponNo: '',
        name:'',
        beginDate:'',
        endDate:'',
        couponName:''
      }
    }
  },
  methods:{
    exportTemplateHandle(){
      var params = qs.stringify({
        'token': Cookies.get('token'),
        ...this.dataForm
      })
      window.location.href = `${window.SITE_CONFIG['apiURL']}${this.exportTemplateURL}?${params}`
    },
    uploadFile (item) {
      const form = new FormData();
      form.append('token', this.token);
      form.append('uploadFile', item.file);
      this.$http.post('/sms/ticketcoupon/readExcel',form).then(res => {
        let data = res.data;
        this.$refs.upload.clearFiles()
        if (data.code == 0) {
          this.$message({
            type: 'success',
            message: '导入成功!'
          });
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: data.msg
          });
        }
      }).catch(err => {
        this.$refs.upload.clearFiles()
      })
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
